(() => {
	'use strict';
	
	function initVariantSelection() {
	  // IMPORTANT: Only select elements from the MAIN product form, not from product cards!
	  const productForm = document.querySelector('form.product-form-main');
	  
	  if (!productForm) {
		return;
	  }
	  
	  // find all variant dropdowns (name="variant1", name="variant2", etc.) ONLY in the main form
	  const variantSelects = [];
	  for (let i = 1; i <= 3; i++) {
		const select = productForm.querySelector('select[name="variant' + i + '"]');
		if (select) {
		  variantSelects.push(select);
		}
	  }
	  
	  const variantIdField = productForm.querySelector('select[name="id"]');
	  
	  if (!variantSelects.length || !variantIdField) {
		return;
	  }
	  
	  let lastVariantId = variantIdField.value; 
	  
	  // button logic: find and toggle the buttons.
	  function getMainProductContainers() {
		return [
		  productForm,
		  document.querySelector('.section-product__quick-add')
		].filter(Boolean);
	  }

	  function getButtons() {
		const containers = getMainProductContainers();
		const addToCart = [];
		const waitlist = [];
		containers.forEach(function(container) {
		  container.querySelectorAll('.button-add-to-cart').forEach(function(btn) { addToCart.push(btn); });
		  container.querySelectorAll('.klaviyo-bis-trigger, [data-js-size-waitlist]').forEach(function(btn) {
			// Komplett ausverkauft: der Waitlist-Button ersetzt den ATC und bleibt
			// sichtbar. "Notify me" in den Dropdown-Zeilen wird nicht mitgeschaltet.
			if (btn.hasAttribute('data-js-waitlist-trigger')) return;
			if (btn.hasAttribute('data-js-size-notify')) return;
			if (waitlist.indexOf(btn) !== -1) return;
			waitlist.push(btn);
		  });
		});
		return { addToCart: addToCart, waitlist: waitlist };
	  }

	  function showAddToCartButton() {
		const buttons = getButtons();
		if (!buttons.addToCart.length || !buttons.waitlist.length) return;

		buttons.addToCart.forEach(function(btn) {
		  btn.classList.remove('button--hidden');
		  btn.style.display = '';
		  btn.disabled = false;
		});
		buttons.waitlist.forEach(function(btn) {
		  btn.classList.add('button--hidden');
		  btn.style.display = 'none';
		});
	  }

	  function showWaitlistButton() {
		const buttons = getButtons();
		if (!buttons.addToCart.length || !buttons.waitlist.length) return;

		buttons.addToCart.forEach(function(btn) {
		  btn.classList.add('button--hidden');
		  btn.style.display = 'none';
		  btn.disabled = true;
		});
		buttons.waitlist.forEach(function(btn) {
		  btn.classList.remove('button--hidden');
		  btn.style.display = '';
		  if (btn.dataset.labelNotify) {
			btn.textContent = btn.dataset.labelNotify;
		  }
		});
	  }

	  function toggleButtons(isAvailable) {
		if (isAvailable) {
		  showAddToCartButton();
		} else {
		  showWaitlistButton();
		}
	  }

	  function getSelectedValues() {
		const selectedValues = [];
		variantSelects.forEach(function(select) {
		  const selectedValue = select.value;
		  if (selectedValue && selectedValue !== '') {
			selectedValues.push(selectedValue);
		  }
		});
		return selectedValues;
	  }

	  function resetVariantField() {
		if (!variantIdField.disabled || variantIdField.value !== '') {
		  variantIdField.disabled = true;
		  variantIdField.value = '';
		  lastVariantId = '';
		}
		toggleButtons(true);
	  }

	  function checkVariantMatch(option, selectedValues) {
		const variant1 = option.getAttribute('data-variant1');
		const variant2 = option.getAttribute('data-variant2');
		const variant3 = option.getAttribute('data-variant3');
		
		if (selectedValues.length >= 1) {
		  if (variant1 && variant1 !== selectedValues[0]) return false;
		  if (!variant1 && selectedValues[0]) return false;
		}
		
		if (selectedValues.length >= 2) {
		  if (variant2 && variant2 !== selectedValues[1]) return false;
		  if (!variant2 && selectedValues[1]) return false;
		}
		
		if (selectedValues.length >= 3) {
		  if (variant3 && variant3 !== selectedValues[2]) return false;
		  if (!variant3 && selectedValues[2]) return false;
		}
		
		return true;
	  }

	  function findMatchingVariant(selectedValues) {
		const variantOptions = variantIdField.querySelectorAll('option');
		
		for (const option of variantOptions) {
		  if (checkVariantMatch(option, selectedValues)) {
			return {
			  option: option,
			  isAvailable: option.getAttribute('data-status') === 'available'
			};
		  }
		}
		
		return null;
	  }

	  function syncSelectedVariant(variantId) {
		if (!variantId) return;
	
		// Keep the URL's ?variant= param in sync so third-party apps that read it
		// (wishlist / recommender / analytics) pick up the currently selected variant
		// instead of falling back to the first available one.
		try {
		  const url = new URL(window.location.href);
		  if (url.searchParams.get('variant') !== String(variantId)) {
			url.searchParams.set('variant', variantId);
			window.history.replaceState({}, '', url.toString());
		  }
		} catch (err) { /* noop */ }
	
		// Update Zooomy wishlist mounts belonging to THIS product only. Scoping to
		// the main product's section prevents cards in sibling sections (e.g.
		// "Complete the Look") from inheriting the wrong variant id.
		const mainSection = productForm.closest('.shopify-section') || productForm;
		const mainProductId = productForm.dataset.productId
		  || (productForm.querySelector('[name="product-id"]') || {}).value;
		const wishlistRoots = [mainSection, document.querySelector('[data-js-sticky-atc]')].filter(Boolean);
		wishlistRoots.forEach(function(root) {
		  root.querySelectorAll('.wishlist-engine').forEach(function(el) {
			if (mainProductId && el.dataset.product_id && el.dataset.product_id !== String(mainProductId)) {
			  return;
			}
			el.setAttribute('data-variant_id', variantId);
		  });
		});
	  }
	
	  function setVariantId(matchedVariant, isAvailable) {
		const newVariantId = matchedVariant.option.value;
		// Sold-out options are disabled in Liquid. Browsers will not assign
		// select.value to a disabled option, so Klaviyo never sees the variant.
		matchedVariant.option.disabled = false;
		const hasChanged = variantIdField.value !== newVariantId || variantIdField.disabled;
		const previousVariantId = lastVariantId;
	
		if (hasChanged) {
		  variantIdField.value = newVariantId;
		  variantIdField.disabled = false;
		  lastVariantId = newVariantId;
	
		  toggleButtons(isAvailable);
	
		  syncSelectedVariant(newVariantId);
	
		  if (previousVariantId !== newVariantId) {
			// Fire a native change event so apps listening on the hidden id field
			// (Zooomy wishlist engine, Rebuy, etc.) react to the new selection.
			variantIdField.dispatchEvent(new Event('change', { bubbles: true }));
	
			document.dispatchEvent(new CustomEvent('variant:change', {
			  detail: {
				variantId: newVariantId,
				variant: matchedVariant.option
			  }
			}));
		  }
		} else {
		  toggleButtons(isAvailable);
		  // Single-variant products already have this id selected by the browser,
		  // so hasChanged is false. Still publish ?variant= for apps that read it.
		  syncSelectedVariant(newVariantId);
		}
	  }
	  
	  function updateVariantId() {
		const selectedValues = getSelectedValues();
		
		// if not all options are selected
		if (selectedValues.length !== variantSelects.length) {
		  resetVariantField();
		  return;
		}
		
		// find the matching variant
		const matchedVariant = findMatchingVariant(selectedValues);
		
		if (matchedVariant) {
		  setVariantId(matchedVariant, matchedVariant.isAvailable);
		} else {
		  resetVariantField();
		}
	  }
	  
	  // event listener for all dropdowns - with debounce, to avoid multiple calls
	  let updateTimeout;
	  variantSelects.forEach(function(select) {
		select.addEventListener('change', function() {
		  clearTimeout(updateTimeout);
		  // Hide error message for this specific fieldset when user selects something
		  const fieldset = select.closest('fieldset');
		  if (fieldset) {
			const errorElement = fieldset.querySelector('.select-error');
			if (errorElement && select.value && select.value !== '') {
			  errorElement.classList.add('hidden');
			}
		  }
		  updateTimeout = setTimeout(updateVariantId, 10); 
		});
	  });

	  // Synchronously resolve select[name="id"] (clears the 10ms debounce). Used by
	  // validateBeforeSubmit and by the size-drawer ATC, which posts FormData itself
	  // and would otherwise send a missing/stale id while the field is still disabled.
	  function resolveVariantIdNow() {
		clearTimeout(updateTimeout);
		updateVariantId();
		return Boolean(variantIdField.value && !variantIdField.disabled);
	  }
	  productForm.resolveVariantId = resolveVariantIdNow;
	  
	  // Validation function that can be called from both button click and form submit
	  function validateBeforeSubmit(e) {
		resolveVariantIdNow();
		
		// Check if all variant dropdowns are selected
		const allSelected = variantSelects.every(function(select) {
		  return select.value && select.value !== '';
		});
		
		if (!allSelected || !variantIdField.value || variantIdField.disabled) {
		  if (e) {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
		  }

		  // Mit aktivem Groessen-Dropdown sind die nativen Selects visuell
		  // collapsed (sticky ATC bleibt oft aktiv). Statt unsichtbare Controls
		  // zu fokussieren, Dropdown oeffnen und zur Groessenwahl fuehren.
		  if (typeof productForm.openSizeDrawer === 'function') {
			productForm.openSizeDrawer({ showError: true });
			return false;
		  }
		  
		  // Find the first unselected variant dropdown and focus it to open the dropdown
		  const firstUnselectedDropdown = variantSelects.find(function(select) {
			return !select.value || select.value === '';
		  });
		  
		  if (firstUnselectedDropdown) {
			const isMobile = window.innerWidth <= 768;
			
			if (isMobile) {
			  // On mobile: Scroll to the dropdown first
			  firstUnselectedDropdown.scrollIntoView({ behavior: 'smooth', block: 'center' });
			  
			  // Focus the dropdown after scrolling (small delay to allow scroll to complete)
			  setTimeout(function() {
				firstUnselectedDropdown.focus();
				
				// Try to open the dropdown programmatically (works on some browsers/devices)
				if (typeof firstUnselectedDropdown.showPicker === 'function') {
				  try {
					firstUnselectedDropdown.showPicker();
				  } catch (err) {
					// showPicker() may fail in some contexts, ignore the error
				  }
				}
			  }, 300);
			} else {
			  // On desktop: Just focus without scrolling
			  firstUnselectedDropdown.focus();
			  
			  if (typeof firstUnselectedDropdown.showPicker === 'function') {
				try {
				  firstUnselectedDropdown.showPicker();
				} catch (err) {
				  // showPicker() may fail in some contexts, ignore the error
				}
			  }
			}
		  }
		  
		  return false;
		}
		
		// check if the variant is available
		const selectedOption = variantIdField.querySelector('option[value="' + variantIdField.value + '"]');
		if (selectedOption && selectedOption.getAttribute('data-status') !== 'available') {
		  if (e) {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
		  }

		  const buttons = getButtons();
		  if (buttons.waitlist) {
			buttons.waitlist.click();
		  }
		  return false;
		}
		
		return true;
	  }

	  // important: event listener for form submit - update the variant ID before the submit
	  if (productForm) {
		// Use capture phase to intercept early and prevent other handlers
		productForm.addEventListener('submit', function(e) {
		  if (!validateBeforeSubmit(e)) {
			// Prevent the form from submitting
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			
			// Also prevent any formProductAdded events from being triggered
			// by stopping the event immediately
			return false;
		  }
		}, true); // Use capture phase to intercept early
		
		// Also add click listener on buttons to prevent form submission if validation fails
		const addToCartButtons = productForm.querySelectorAll('.button-add-to-cart');
		addToCartButtons.forEach(function(button) {
		  // Store original button text for hover functionality
		  const originalText = button.textContent.trim();
		  
		  button.addEventListener('click', function(e) {
			// Only prevent if validation fails
			if (!validateBeforeSubmit(e)) {
			  e.preventDefault();
			  e.stopPropagation();
			  e.stopImmediatePropagation();
			  return false;
			}
		  }, true); // Use capture phase - this runs before the default action
		  
		  if (button.hasAttribute('data-js-dropdown-atc')) {
			return;
		  }

		  // Hover functionality: show "Please select a size" if no variant is selected
		  button.addEventListener('mouseenter', function() {
			const allSelected = variantSelects.every(function(select) {
			  return select.value && select.value !== '';
			});
			
			if (!allSelected) {
			  // Use translated text from data attribute, fallback to default
			  const selectSizeText = button.getAttribute('data-select-size-text') || 'Please select a size';
			  button.textContent = selectSizeText;
			}
		  });
		  
		  button.addEventListener('mouseleave', function() {
			button.textContent = originalText;
		  });
		});
	  }
	  
	  updateVariantId();
	  
	  // Klassisches Dropdown: Auswahl nach dem Add-to-Cart zuruecksetzen.
	  // Im Groessen-Dropdown bleibt die zuletzt gewaehlte Groesse stehen.
	  document.addEventListener('formProductAdded', function() {
		if (document.querySelector('[data-js-size-dropdown]')) {
		  return;
		}

		variantSelects.forEach(function(select) {
		  select.selectedIndex = 0;
		  select.value = '';
		});

		variantIdField.value = '';
		updateVariantId();
	  });
	}
	
	if (document.readyState === 'loading') {
	  document.addEventListener('DOMContentLoaded', initVariantSelection);
	} else {
	  initVariantSelection();
	}
})();
